import { capitalize, lowerCase } from 'lodash';
import moment from 'moment-timezone';
import { ageFromDateIso, ValidDateFormats } from './DateUtilities';
export function insertSubString(original, position, value) {
    return [original.slice(0, position), value, original.slice(position)].join('');
}
export function formatNumber(num) {
    return num.toLocaleString();
}
export function currencyFormat(num) {
    return num.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}
export function sentenceCase(value) {
    return capitalize(lowerCase(value));
}
export function caseInsensitiveStringSort(a, b) {
    return a.toLowerCase().localeCompare(b.toLowerCase());
}
export function nameFirstLast(first, last) {
    return [first, last].filter(function (n) { return !!n; }).join(' ');
}
export function nameTitleFirstLast(title, first, last) {
    return [title, first, last].filter(function (n) { return !!n; }).join(' ');
}
export function nameLastFirstTitle(last, first, title) {
    var lastName = last || '';
    var name = [lastName.toUpperCase(), first].filter(function (n) { return !!n; }).join(', ');
    if (title)
        name += " (" + capitalize(title) + ")";
    return name;
}
export function toTitleCase(str) {
    if (!str)
        return str;
    return str.replace(/([^\W_]+[^\s-]*) */g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}
export function trimRight(str, charToBeTrimmed) {
    if (!str || !charToBeTrimmed)
        return str;
    var regexp = new RegExp("\\" + charToBeTrimmed + "*$");
    return str.replace(regexp, '');
}
export function capitalizeFirstLetter(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
export function toLowerCaseFirstLetter(value) {
    return value.charAt(0).toLowerCase() + value.slice(1);
}
export function standardName(nameParts) {
    var givenNames = nameParts.givenNames, familyName = nameParts.familyName, middleNames = nameParts.middleNames, title = nameParts.title;
    var formatTitle = function (str) {
        var formatted = str || '';
        formatted = trimRight(formatted, '.');
        formatted = toTitleCase(formatted);
        formatted = !!formatted ? "(" + formatted + ")" : formatted;
        return formatted;
    };
    var formattedTitle = formatTitle(title || '');
    var formattedMiddleNames = toTitleCase(middleNames || '');
    var formattedGivenNames = toTitleCase(givenNames || '');
    var formattedFamilyName = (familyName || '').toUpperCase();
    var formattedName = [formattedFamilyName, formattedGivenNames].filter(function (x) { return !!x; }).join(', ');
    return [formattedName, formattedMiddleNames, formattedTitle].filter(function (x) { return !!x; }).join(' ');
}
export function createPatientInfoLine(patient) {
    var patientName = standardName({
        familyName: patient.familyName || '',
        givenNames: patient.givenNames || '',
        middleNames: patient.middleNames || ''
    });
    var patientDateOfBirth = !!patient.dateOfBirth
        ? moment(patient.dateOfBirth, ValidDateFormats.IsoFormat).format(ValidDateFormats.Display)
        : '';
    var patientAge = !!patient.dateOfBirth ? ageFromDateIso(patient.dateOfBirth) : '';
    var dobAgeGenderInfo = [patientDateOfBirth, patientAge, !!patient.sex ? capitalize(patient.sex.name) : '']
        .filter(function (it) { return !!it; })
        .join(' | ');
    return [patientName, dobAgeGenderInfo].filter(function (it) { return !!it; }).join(', ');
}
export function displayCurrency(amount, opts) {
    var myOpts = {
        locale: (opts && opts.locale) || 'en-AU',
        currency: (opts && opts.currency) || 'AUD',
        displayWhenEmpty: (opts && opts.displayWhenEmpty) || '-',
        displayWhenInvalid: (opts && opts.displayWhenInvalid) || '-',
        displayWhenZero: (opts && opts.displayWhenZero) || '$0.00'
    };
    if (typeof amount === 'number') {
        return formatNumberAsCurrency(amount, myOpts);
    }
    return formatStringAsCurrency(amount, myOpts);
}
function formatNumberAsCurrency(amount, opts) {
    if (Number.isNaN(amount))
        return opts.displayWhenInvalid;
    if (amount === 0)
        return opts.displayWhenZero;
    var locale = opts.locale, currency = opts.currency;
    return amount.toLocaleString(locale, { style: 'currency', currency: currency });
}
function formatStringAsCurrency(amount, opts) {
    if (!amount || amount.trim() === '')
        return opts.displayWhenEmpty;
    var cleaned = amount.replace(/[^0-9\.]/g, '');
    if (cleaned === '')
        return opts.displayWhenInvalid;
    var asNumber = Number(cleaned);
    return formatNumberAsCurrency(asNumber, opts);
}
export function singularisePluralise(value, count) {
    return count > 1 ? value + 's' : value;
}
